var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.65 6.35A7.95 7.95 0 0012 4V1l-4 4 4 4V6c3.31 0 6 2.69 6 6 0 1.3-.41 2.5-1.1 3.47l1.46 1.46A7.932 7.932 0 0020 12c0-2.21-.9-4.21-2.35-5.65zM6.35 17.65A7.95 7.95 0 0012 20v3l4-4-4-4v3c-3.31 0-6-2.69-6-6 0-1.3.41-2.5 1.1-3.47l-1.46-1.46A7.932 7.932 0 004 12c0 2.21.9 4.21 2.35 5.65z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.d6a2c337a26e59067a36ba6171b147ce.svg";
export { ForwardRef as ReactComponent };